import { render } from "./Tour.vue?vue&type=template&id=fc21fcae&scoped=true"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"

import "./Tour.vue?vue&type=style&index=0&id=fc21fcae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc21fcae"]])

export default __exports__